import {
  Box,
  Columns,
  ColumnsItem,
  Icon,
  IconName,
  Link,
  RowItem,
  Text,
  TextLevels,
  Title,
  TitleLevels,
} from '@bytel/trilogy-react-ts';
import { sentenceToString } from '@shared/misc/helpers/strings';
import React from 'react';
import { Trans } from 'react-i18next';
import { Link as routerLink } from 'react-router-dom';
import './style.css';
import { NavigationItemProps } from './type';

const NavigationItem: React.FC<NavigationItemProps> = ({ config }) => {
  const { label, link, description, backgroundName } = config;

  return (
    <Box className={`is-shadowless is-radiusless ${backgroundName ? `header-${backgroundName}` : ''}`}>
      <Columns className="is-marginless ">
        <Link
          to={link?.href}
          removeLinkClass
          className="has-text-primary"
          data-cy="link-previous"
          key={sentenceToString(label)}
          routerLink={routerLink}
        >
          <Icon name={IconName.ARROW_LEFT} size="medium" className="has-text-primary" />
        </Link>
        <ColumnsItem verticalCenter>
          <Title
            data-cy={backgroundName ? `${backgroundName}-title` : `link-${sentenceToString(label)}`}
            level={TitleLevels.TWO}
            className="is-unselectable"
          >
            {label}
          </Title>
        </ColumnsItem>
      </Columns>
      {description && (
        <RowItem>
          {description.boldDescription && (
            <Text level={TextLevels.ONE} className="has-text-weight-bold">
              {description.boldDescription}
            </Text>
          )}
          <Text level={TextLevels.TWO} data-cy={backgroundName ? `${backgroundName}-description` : undefined}>
            <Trans>{description.sousDescription}</Trans>
          </Text>
        </RowItem>
      )}
    </Box>
  );
};

export default NavigationItem;
